export type PaymentContext = {
    clientId?: number;
    providerId?: number;
    creditCardOnFile?: boolean;
    isGroupPractice?: boolean;
};

/** Presentation is always available; financial entry requires provider-scoped context. */
export function paymentActionBlock(context: PaymentContext): 'provider' | 'card' | 'unknown-card' | null {
    if (context.creditCardOnFile === false) return 'card';
    if (context.creditCardOnFile !== true) return 'unknown-card';
    const validId = (id?: number) => typeof id === 'number' && Number.isSafeInteger(id) && id > 0;
    if (context.isGroupPractice || !validId(context.clientId) || !validId(context.providerId)) return 'provider';
    return null;
}
